import { defineComponent, onMounted, onUnmounted, ref } from 'vue';
import EventBus from '../../scripts/lib/EventBus.js';
import type { EntsDrawer } from '../drawer/drawer.js';

const templateElement = document.getElementById('certified-columns-template');
export default defineComponent({
  template: templateElement ? templateElement.innerHTML : '',

  setup() {
    const drawer = ref<EntsDrawer | null>(null);

    onMounted(() => {
      EventBus.on('ents:vue:certified-columns:drawer:open', openCertifiedDrawer);
    });

    onUnmounted(() => {
      EventBus.off('ents:vue:certified-columns:drawer:open', openCertifiedDrawer);
    });

    const openCertifiedDrawer = async () => {
      await import('../drawer/drawer.js');
      (drawer.value as EntsDrawer).show();
    };

    return {
      drawer,
    };
  },
});
